export default {
  GET_TRIUMPH_PAY_URL: '@PAYMENTS_CONNECT/GET_TRIUMPH_PAY_URL',
  GET_TRIUMPH_PAY_URL_SUCCESS: '@PAYMENTS_CONNECT/GET_TRIUMPH_PAY_URL_SUCCESS',
  GET_TRIUMPH_PAY_URL_FAILURE: '@PAYMENTS_CONNECT/GET_TRIUMPH_PAY_URL_FAILURE',

  GENERATE_TRIUMPH_PAY_TOKEN: '@PAYMENTS_CONNECT/GENERATE_TRIUMPH_PAY_TOKEN',
  GENERATE_TRIUMPH_PAY_TOKEN_SUCCESS: '@PAYMENTS_CONNECT/GENERATE_TRIUMPH_PAY_TOKEN_SUCCESS',
  GENERATE_TRIUMPH_PAY_TOKEN_FAILURE: '@PAYMENTS_CONNECT/GENERATE_TRIUMPH_PAY_TOKEN_FAILURE'
}
